import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { FeedbackError, Input, TranslucentContainer } from '../../../../../components';
import { useIsMobile } from '../../../../../hooks/useIsMobile';

function ContactPoint({ values, handleChange, handleBlur, touched, errors }) {
  const isMobile = useIsMobile();

  return (
    <TranslucentContainer style={{ width: isMobile ? '100%' : '80%' }}>
      <Grid container justifyContent="space-evenly" paddingTop={isMobile ? 2 : 8}>
        <Grid item xs={12} sm={3.1} marginBottom={1}>
          <Input
            placeholder="Contact Name"
            name="contact_name"
            type="text"
            value={values.contact_name}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.contact_name && touched.contact_name && 'error'}
          />
          <FeedbackError name="contact_name" errors={errors} touched={touched} />
        </Grid>
        <Grid item xs={12} sm={3.1} marginBottom={1}>
          <Input
            placeholder="Contact Phone Number"
            name="contact_phone_number"
            type="text"
            value={values.contact_phone_number}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.contact_phone_number && touched.contact_phone_number && 'error'}
          />
          <FeedbackError name="contact_phone_number" errors={errors} touched={touched} />
        </Grid>
        <Grid item xs={12} sm={8.1} marginBottom={1}>
          <Input
            type="text"
            placeholder="Contact Email"
            name="contact_email"
            value={values.contact_email}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.contact_email && touched.contact_email && 'error'}
          />
          <FeedbackError name="contact_email" errors={errors} touched={touched} />
        </Grid>
      </Grid>
    </TranslucentContainer>
  );
}

ContactPoint.propTypes = {
  values: PropTypes.shape({
    contact_name: PropTypes.string.isRequired,
    contact_email: PropTypes.string.isRequired,
    contact_phone_number: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.shape({
    contact_name: PropTypes.string.isRequired,
    contact_email: PropTypes.string.isRequired,
    contact_phone_number: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    contact_name: PropTypes.string.isRequired,
    contact_email: PropTypes.string.isRequired,
    contact_phone_number: PropTypes.string.isRequired,
  }).isRequired,
};

export default ContactPoint;
